module.exports = __webpack_public_path__ + "static/media/Artboard 1.57a16aca.png";